































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import DateFormatter from "../../shared/DateFormatter";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "SettingsNotifications",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      checkModuleIsActivated: checkModuleIsActivated,
      settingsNotifications: null as SettingsNotificationsJson | null,
      hasChanges: false as boolean,
      showHints: {},
      isSaveDataLoading: false,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    this.loadData();
  },
  mounted() {},
  methods: {
    loadData() {
      this.loadSettingsNotifications();
    },

    async loadSettingsNotifications() {
      this.settingsNotifications = null;

      try {
        this.settingsNotifications = await this.restClient.getSettingsNotifications();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }
    },

    async saveSettingsNotifications() {
      if (this.settingsNotifications != null) {
        this.isSaveDataLoading = true;

        try {
          this.settingsNotifications = await this.restClient.saveSettingsNotifications(this.settingsNotifications);

          this.$emit("reloadSettingsNotifications");

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert("Speichern fehlgeschlagen: " + e.message);
        }

        this.isSaveDataLoading = false;
      } else {
        alert("Die Daten konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Angaben.");
      }
    },

    discardChanges() {
      this.loadSettingsNotifications();
    },

    /*** START control cached data ***/

    /* set cached data */

    /* format and set data where be cached */

    /*** END control cached data ***/

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    settingsNotifications: {
      deep: true,
      handler() {
        this.hasChanges = true;
      },
    },

    hasChanges: {
      deep: true,
      handler() {
        this.$emit("changesInChild", this.hasChanges);
      },
    },
  },
  computed: {},
});
